module.exports = __webpack_public_path__ + "static/media/Homebg.c0edaef1.jpg";